module.exports = __webpack_public_path__ + "static/media/inverterCorrect.8ece8129.png";